<template>
    <w-flex>
        <w-card class="fill-width center red-light5--bg corner-round pa3">
            <span class="top">
                 <router-link :to="back" v-if="back && !close" hover class="left" @click="emit('close')">
                    <w-icon>mdi
                        mdi-arrow-left</w-icon> Go back</router-link> <w-icon v-if="close" @click="emit('close')"
                    class="right">mdi
                    mdi-close</w-icon>
                </span>
            <strong class="title2">{{ status }}</strong>
            <p>{{ message }}</p>
        </w-card>
    </w-flex>
</template>
<script>

export default {
    name: "AlertComponent",
    props: {
        status: String,
        message: String,
        close: Boolean,
        back: String,
    },
    setup(props, { emit }) {
        return {
            props,
            emit
        }
    }
}
</script>
<style scoped>
.top {
    position: relative;
    top: 1%;
}

.bottom {
    position: relative;
    bottom: 25px;
}

.left {
    position: relative;
    left: -40%;
}

.right {
    position: relative;
    right: -50%;
}

.top.left,
.top.left {
    position: relative
}
</style>